import Vue from 'vue'
import { random_rgb, setFavicon } from '@/helpers/utils'
import { convertArrayToObject } from '../helpers/utils'
const { DateTime } = require('luxon')
import merge from 'lodash.merge'
const requests = {
  address: null
}
import fileSaver from 'file-saver'

export default {
  getPeriods({ dispatch, getters, commit }) {
    return Vue.http
      .get(getters.endpoint.period, {
        params: {
          workspace: getters.workspace,
          version: getters.version,
          limit: 1000 //По умолчанию бэк отдает только 100 периодов, по ТЗ должно быть 120, 1000 - это значение с запасом
        }
      })
      .then((r) => {
        let periods = r.body.results

        if (getters.isPublicWs) {
          const currentWs = getters.currentWs[0]
          const firstShownPeriodId = currentWs.first_shown_period_id
          const lastShownPeriodId = currentWs.last_shown_period_id

          let periodStartIndex = periods.findIndex((periodItem) => {
            return periodItem.id === firstShownPeriodId
          })
          if (periodStartIndex === -1) {
            periodStartIndex = 0
          }

          let periodEndIndex = periods.findIndex((periodItem) => {
            return periodItem.id === lastShownPeriodId
          })
          if (periodEndIndex === -1) {
            periodEndIndex = periods.length
          }

          periods = periods.slice(Math.min(periodStartIndex, periodEndIndex), Math.max(periodStartIndex, periodEndIndex) + 1)
        }

        commit('setPeriods', periods)
      })
  },
  getYears({ dispatch, commit, getters }) {
    return Vue.http
      .get(getters.endpoint.year, {
        params: {
          workspace: getters.workspace,
          version: getters.version
        }
      })
      .then((r) => {
        commit('setYears', r.body.results)
      })
  },
  getSeasons({ dispatch, commit, getters }) {
    return Vue.http
      .get(getters.endpoint.seasons, {
        params: {
          workspace: getters.workspace,
          version: getters.version,
          limit: 1000 //По умолчанию бэк отдает только 100 периодов, по ТЗ должно быть 120, 1000 - это значение с запасом
        }
      })
      .then((r) => {
        commit('setSeasons', r.body.results)
      })
  },
  getZones({ dispatch, getters, commit }) {
    return Vue.http
      .get(getters.endpoint.zones, {
        params: {
          workspace: getters.workspace,
          version: getters.version
        }
      })
      .then((r) => {
        commit(
          'setZones',
          r.body.results.map((v) => {
            return {
              ...v,
              name: v.name || 'Зона ' + v.id,
              color: random_rgb()
            }
          })
        )
      })
  },
  getZoneGroups({ dispatch, getters, commit }) {
    return Vue.http
      .get(getters.endpoint.zonegroups, {
        params: {
          workspace: getters.workspace,
          version: getters.version
        }
      })
      .then((r) => {
        commit(
          'setZoneGroups',
          r.body.results.map((v) => {
            return {
              ...v,
              color: random_rgb()
            }
          })
        )
      })
  },
  getAvailableAdmTerritories({ dispatch, getters, commit }) {
    return Vue.http
      .get(getters.endpoint.admterritory, {
        params: {
          workspace: getters.workspace,
          version: getters.version,
          limit: 2000000,
          fields: 'id,name,adm_level,center,treatment_types,user_id'
        }
      })
      .then((r) => {
        commit('setAdmTerritories', r.body.results)
        return dispatch('getSeparatedTerritories')
      })
  },
  getSeparatedTerritories({ dispatch, getters, commit }) {
    return Vue.http
      .get(getters.endpoint.separateterritory, {
        params: {
          workspace: getters.workspace,
          version: getters.version,
          limit: 2000000,
          fields: 'adm_territory,id,name,center,treatment_type,treatment_types,user_id'
        }
      })
      .then((r) => {
        commit('setSeparatedTerritories', r.body.results)
      })
  },
  getLogo({ getters, commit }) {
    return Vue.http
      .get(getters.endpoint.icon, {
        params: {
          type: 'logo',
          workspace: getters.workspace,
          version: getters.version
        }
      })
      .then((r) => {
        const logo = r.body.results && r.body.results.length > 0 && r.body.results[0].icon_file ? r.body.results[0].icon_file.file || 'default' : 'default'
        commit('setLogo', logo)

        //Установка ссылки на favicon
        setFavicon(logo && logo !== 'default' ? logo : '/static_assets/favicon.ico')
      })
      .catch((e) => {
        commit('setLogo', 'default')
      })
  },

  /**
   * Загрузка настроек рабочего пространства
   * @param {*} param0
   * @param {*} params
   * @param {*} params.name
   * @param {*} params.saveId
   * @param {*} params.category
   * @returns
   */
  loadWorkspaceSettings({ commit, getters }, { name, saveId, category = 'frontend' }) {
    let requestParams = {}
    if (name) {
      //Загрузка настроек по названию
      requestParams.name = name
    } else if (category) {
      //Или по категории
      requestParams.category = category
    } else {
      //Если ничего не передали то не грузим
      return Promise.resolve(false)
    }

    return Vue.http
      .get(getters.endpoint.settings, {
        params: {
          workspace: getters.workspace,
          version: getters.version,
          ...requestParams
        }
      })
      .then((r) => {
        const settings = {}
        r.body.results.forEach((setting) => {
          if (setting.name === 'centroid') {
            if (!setting.value[0].center) {
              setting.value[0].center = getters.defaultSettings.centroid[0].center
            }
            if (!setting.value[0].zoom) {
              setting.value[0].zoom = getters.defaultSettings.centroid[0].zoom
            }
          }
          if (setting.name === 'flow_problems_list') {
            setting.value.no_problem = 'Без проблем'
          }
          if (setting.name === 'bbox_min_zoom') {
            setting.value = setting.value[0] ? setting.value[0].zoom : getters.defaultSettings.bbox_min_zoom
          }

          // обязательно должен присутствовать в ответе, даже если value пустое.
          if (setting.name === 'front_layer_layout') {
            if (!setting.value || typeof setting.value !== 'object') {
              setting.value = { ...getters.defaultSettings.front_layer_layout }
            }
            commit('setObjectLayersInfo', setting.value.layerSettings || {})
          }
          settings[setting.name] = setting.value
          if (saveId) {
            settings[setting.name].id = setting.id
          }
        })
        commit('setSettings', settings)

        return settings
      })
      .catch((e) => {
        console.log(e)
      })
  },

  /**
   * Старое действие, используется в компоненте src\components\objects\priorities\PriorityRules.vue
   * Предположительно не работает так как неправильно оюрабатывается результат
   * TODO: исправить, когда будет найден момент вызова из интерфейса
   * @param {*} param0
   * @param {*} params
   * @returns
   */
  updateSettings({ commit, getters }, params) {
    return Vue.http
      .patch(
        getters.endpoint.setting(params.id),
        { value: params.value },
        {
          params: {
            workspace: getters.workspace,
            version: getters.version
          }
        }
      )
      .then((r) => {
        commit('setSettings', {
          [r.name]: {
            id: r.body.id,
            value: r.body.results[0]
          }
        })
      })
  },

  /**
   * Отдельно действие по обновлению настроек приоритетов (задача https://app.clickup.com/t/325z1rh. Приоритеты переименованы в ограничениями)
   * @param {*} param0
   * @param {*} params
   * @returns
   */
  updatePrioritySettings({ commit, getters }, params) {
    return Vue.http
      .patch(
        getters.endpoint.setting(params.id),
        { value: params.value },
        {
          params: {
            workspace: getters.workspace,
            version: getters.version
          }
        }
      )
      .then((r) => {
        commit('setSettings', {
          [r.body.name]: {
            id: r.body.id,
            ...r.body.value
          }
        })
      })
  },

  getAdmLevels({ commit, getters }) {
    return Vue.http
      .get(getters.endpoint.admLevels, {
        params: {
          workspace: getters.workspace,
          version: getters.version
        }
      })
      .then((r) => {
        commit('setAdmLevels', r.body)
      })
  },
  getConvertfunctions({ commit, getters }) {
    return Vue.http
      .get(getters.endpoint.convertfunctions, {
        params: {
          workspace: getters.workspace,
          version: getters.version,
          limit: 1000
        }
      })
      .then((r) => {
        commit('setConvertfunctions', r.body.results)
      })
  },
  getEconomicModels({ commit, getters }) {
    return Vue.http
      .get(getters.endpoint.economicModels, {
        params: {
          workspace: getters.workspace,
          version: getters.version,
          limit: 1000
        }
      })
      .then((r) => {
        commit('setEconomicModels', r.body.results)
      })
  },

  getEmitterCategorytypes({ getters, commit }) {
    return Vue.http
      .get(getters.endpoint.categorytypeList, {
        params: {
          workspace: getters.workspace,
          version: getters.version,
          limit: 1000
        }
      })
      .then((r) => {
        commit('setEmitterCategorytypes', r.data.results)
      })
  },
  uploadFile({ getters }, params) {
    const multipart = new FormData()
    Object.keys(params).forEach((key) => {
      multipart.append(key, params[key])
    })
    return Vue.http.post(getters.endpoint.uploadFile, multipart, {
      params: {
        workspace: getters.workspace,
        version: getters.version
      }
    })
  },
  resetAppBasicDatas({ commit, getters }) {
    commit('setAdmLevels', null)
    commit('setYears', null)
    commit('setSeasons', null)
    commit('setPeriods', null)
    commit('setSettings', null)
    commit('setAdmTerritories', null)
    commit('setZones', null)
    commit('setZoneGroups', null)
    commit('setTreatments', [])
    commit('setColors', {})
    commit('setEmitterCategorytypes', [])
    commit('setLogo', '')
    commit('setObjectContainerTypes', null)
    commit('setEconomicModels', [])
    commit('setConvertfunctions', [])
  },
  getApiVersion({ getters, commit }) {
    return Vue.http
      .get(getters.endpoint.apiVersion)
      .then((r) => {
        if (r.body) {
          r.body.code_last_change_time = DateTime.fromFormat(r.body.code_last_change_time, 'dd MMM yyyy TT', { zone: 'utc' })
            .toLocal()
            .toFormat('dd.MM.yyyy T')
        }
        commit('setApiVersion', r.body)
      })
      .catch((e) => {
        console.log("can't get version information")
      })
  },
  globalSearch({ getters, commit }, params) {
    return Vue.http
      .get(getters.endpoint.search(params.type), {
        params: {
          workspace: getters.workspace,
          version: getters.version,
          search: params.text,
          ...params.additional
        }
      })
      .then((r) => {
        return r.data.results.map((v) => {
          return {
            ...v,
            id: v.id || v.obj_id,
            name: v.text || v.name || v.address
          }
        })
      })
      .catch((e) => {})
  },

  getAddressByCoords({ getters, dispatch }, coords) {
    return Vue.http
      .get(getters.endpoint.decodeCoordinates, {
        credentials: false,
        params: {
          lat: coords[0],
          lon: coords[1]
        },
        before(request) {
          dispatch('abortCommonRequest', { request, key: 'address' })
        }
      })
      .then((r) => {
        requests.address = null
        let result = []
        if (r && r.body && Array.isArray(r.body.address) && !r.body.error) {
          return r.body.address.map(({ GeoObject }) => {
            const coords = GeoObject.Point.pos.split(' ')

            return {
              coords: [coords[1], coords[0]],
              address: `${GeoObject.description}, ${GeoObject.name}`
            }
          })

          /*
          Старый код старого геокодера номинатим
          let address = ''
          if (r.body.address) {
            address += r.body.address.state
            address += r.body.address.state_district ? ', ' + r.body.address.state_district : ''
            address += r.body.address.city ? ', ' + r.body.address.city : ''
            address += r.body.address.suburb ? ', ' + r.body.address.suburb : ''
            address += r.body.address.road ? ', ' + r.body.address.road : ''
            address += r.body.address.house_number ? ', ' + r.body.address.house_number : ''
            address += r.body.address.postcode ? ', ' + r.body.address.postcode : ''
          }
          result = [
            {
              coords: [coords[0], coords[1]],
              address: address
            }
          ]
          */
        }
        return result
      })
      .catch((e) => {
        dispatch('handleCommonErrors', e)
      })
  },

  getAddressListByStr({ getters, dispatch }, address) {
    address = address
      .replaceAll(', ', ' ')
      .replaceAll(',', ' ')
      .replaceAll('.', '')
    return Vue.http
      .get(getters.endpoint.encodeCoordinates, {
        credentials: false,
        params: {
          address,
          limit: 100
        },
        before(request) {
          dispatch('abortCommonRequest', { request, key: 'address' })
        }
      })
      .then((r) => {
        requests.address = null
        let result = []
        if (!r.body.error && r && r.body && Array.isArray(r.body.result)) {
          result = r.body.result.map(({ GeoObject }) => {
            const coords = GeoObject.Point.pos.split(' ')

            return {
              coords: [coords[1], coords[0]],
              address: `${GeoObject.description}, ${GeoObject.name}`
            }
          })
        }
        return result
      })
      .catch((e) => {
        dispatch('handleCommonErrors', e)
      })
  },
  abortCommonRequest({}, params) {
    if (requests[params.key]) {
      requests[params.key].abort()
    }
    requests[params.key] = params.request
  },
  handleCommonErrors({}, e) {
    if (e.status === 0) {
      return
    }
    throw e
  },

  getYandexAddressList({ getters, dispatch }, address) {
    return Vue.http
      .get(getters.endpoint.yandexGeo, {
        credentials: false,
        params: {
          lang: 'ru_RU',
          format: 'json',
          apikey: getters.yandexApiKey,
          geocode: address,
          results: 100
        }
      })
      .then((r) => {
        return dispatch('formatYandexGeoResponse', r)
      })
  },
  formatYandexGeoResponse({}, r) {
    let result = []
    if (r.body.response && r.body.response.GeoObjectCollection && r.body.response.GeoObjectCollection.featureMember) {
      result = r.body.response.GeoObjectCollection.featureMember.map((v) => {
        return {
          coords: v.GeoObject && v.GeoObject.Point ? v.GeoObject.Point.pos.split(' ').reverse() : [],
          address:
            v.GeoObject && v.GeoObject.metaDataProperty && v.GeoObject.metaDataProperty.GeocoderMetaData
              ? v.GeoObject.metaDataProperty.GeocoderMetaData.text
              : ''
        }
      })
    }
    return result
  },

  getTreatments({ commit, getters }) {
    return Vue.http
      .get(getters.endpoint.treatments, {
        params: {
          workspace: getters.workspace,
          version: getters.version,
          limit: 1000
        }
      })
      .then((r) => {
        commit(
          'setTreatments',
          r.body.results.map((v) => {
            return {
              ...v,
              name: v.ru_name
            }
          })
        )
      })
  },

  loadItems({ commit, getters }) {
    return Vue.http
      .get(getters.endpoint.item, {
        params: {
          workspace: getters.workspace,
          version: getters.version,
          limit: 1000
        }
      })
      .then((r) => {
        commit('setItems', {
          items: r.body.results
        })
      })
  },

  getColors({ commit, getters }) {
    return Vue.http
      .get(getters.endpoint.color, {
        params: {
          workspace: getters.workspace,
          version: getters.version,
          limit: 1000
        }
      })
      .then((r) => {
        commit('setColors', convertArrayToObject(r.body.results, 'id'))
      })
  },
  initApp({ dispatch, getters }) {
    const actions = []
    actions.push(dispatch('getYears'))
    actions.push(dispatch('getLogo'))
    actions.push(dispatch('getSeasons'))
    actions.push(dispatch('getPeriods'))
    actions.push(dispatch('getColors'))
    actions.push(dispatch('getAdmLevels'))
    actions.push(dispatch('loadWorkspaceSettings', {}))
    //actions.push(dispatch('getAvailableAdmTerritories'))
    actions.push(dispatch('getZones'))
    actions.push(dispatch('getZoneGroups'))
    actions.push(dispatch('getConvertfunctions'))
    actions.push(dispatch('getEconomicModels'))
    actions.push(dispatch('getTreatments'))
    actions.push(dispatch('loadItems'))
    actions.push(dispatch('getContainerTypes'))
    actions.push(dispatch('getEmitterCategorytypes'))
    if (!getters.apiVersion) {
      actions.push(dispatch('getApiVersion'))
    }

    //Для публично ws загрузим списки "Контроль" и "Терсхема" заранее
    //Это нужно, чтобы скрыть пункты меню, если файлов нет в этих разделах
    if (getters.isPublicWs) {
      actions.push(dispatch('loadTerschemaListCount'))
      actions.push(dispatch('loadControlListCount'))
    }

    return Promise.all(actions)
  },

  loadTerschemaListCount({ commit, getters }) {
    return Vue.http
      .get(getters.endpoint.terschema, {
        params: {
          limit: 1,
          workspace: getters.workspace,
          version: getters.version
        }
      })
      .then((r) => {
        commit('setTerschemaListCount', r.body.count)
      })
  },

  loadControlListCount({ commit, getters }) {
    return Vue.http
      .get(getters.endpoint.control, {
        params: {
          limit: 1,
          workspace: getters.workspace,
          version: getters.version
        }
      })
      .then((r) => {
        commit('setControlListCount', r.body.count)
      })
  },

  setTheme({ commit }, theme = '') {
    localStorage.setItem('theme', theme)
    commit('setTheme', theme)
  },
  getFile({ commit }, fileUrl) {
    return Vue.http
      .get(fileUrl, {
        responseType: 'blob'
      })
      .then((r) => {
        const fileUrlParts = fileUrl.split('/')
        fileSaver.saveAs(r.body, fileUrlParts[fileUrlParts.length - 1])
      })
      .catch((e) => {
        commit('setApiErrorInfo', 'Ошибка получения файла')
      })
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js